// extracted by mini-css-extract-plugin
export default {"numberStatCell":"Row_numberStatCell__ywrLr","index":"Row_index__f9Bqh","statusIcon":"Row_statusIcon__mcOHP","rowHolder":"Row_rowHolder__Z0vBc"};